import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FocusShapeType } from '@app/_enums/focus-tracker.enum';

@Component({
  selector: 'app-focus-shape',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './focus-shape.component.html',
  styleUrl: './focus-shape.component.scss'
})
export class FocusShapeComponent {
  @Input({ required: true }) shape!: FocusShapeType;
  @Input() size: number = 48;

  readonly FocusShapeType = FocusShapeType;
}
